import React from 'react';
import PropTypes from 'prop-types';

const Angle6Path = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M5 6a3 3 0 0 0-3 3.001V23a3.001 3.001 0 0 0 3 3.001h14c1.656 0 3-1.345 3-3.001V9.001A3 3 0 0 0 19 6H5zm2.8 10.013c0-4.307 1.891-6.213 4.1-6.213 1.793 0 3.174.985 3.618 2.71h-2.142c-.338-.473-.83-.71-1.476-.71-1.105 0-2.093 1.528-2.093 2.829.589-.341 1.464-.616 2.193-.616a4 4 0 0 1 4 4 4.003 4.003 0 0 1-4 4c-2.209 0-4.2-1.693-4.2-6zm23.082-8.384l-6.627 3.728a.5.5 0 0 0-.255.435v8.415c0 .181.098.348.255.437l6.627 3.728A.75.75 0 0 0 32 23.718V8.282a.752.752 0 0 0-.751-.749.738.738 0 0 0-.367.096zM10 18.013a2 2 0 0 0 4 0 2 2 0 0 0-4 0z"
    />
  );
};

Angle6Path.propTypes = {
  fill: PropTypes.string,
};

export default Angle6Path;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/angle-6.jsx